<div class="alert alert-{{ alert.alertType }}" role="alert" *ngIf="alert.show">
  {{ alert.message }}
</div>
